import RunReport from "./RunReport"


export const tableColumns = [    
    {
      name: "Client",
      selector: (row) => row.name,
      sortable: false,   
    },        
    {
      name: "Total Hours",
      selector: (row) => row.no_of_hours?.toFixed(2),
      sortable: false,
    },
    {
      name: "Total Revenue",
      selector: (row) => '£'+row.total_revenue?.toFixed(2),
      sortable: false,
    },
  ];

const RevenueByClient = () => {    
  return (
    <>
    <RunReport ReportID={3} tableColumns={tableColumns} reportName={"Revenue By Client"}  />
    </>
  )
}

export default RevenueByClient